<template>
  <div>
    <br/>
    <h5 class="pageTitle" style="text-align:center">
      Adhésion au Club des ornithologues de Québec
    </h5>

    <p style="text-align: center; font-weight: 700; font-size: 15px">
      Le bouton d'inscription se trouve tout en bas de la page. Nous vous suggérons de lire le contenu de cette page
      avant.
      <br/><br/>
    </p>

    <p>
      En adhérant au Club des ornithologues de Québec (COQ) vous vous joindrez à
      une famille d'environ 700 membres. Le but principal du COQ est de
      regrouper les personnes intéressées par l’observation des oiseaux et la
      conservation de leurs habitats dans la grande région de Québec.
    </p>

    <p>
      Pour répondre à ses objectifs, le COQ organise annuellement plus d'une
      centaine d'activités variées :
    </p>
    <ul>
      <li>excursions ;</li>
      <li>conférences ;</li>
      <li>recensements ;</li>
      <li>activités sociales ;</li>
      <li>cours d'ornithologie.</li>
    </ul>
    <p>
      En outre, le COQ publie une revue, le <i>Bulletin ornithologique</i>,
      quatre fois par année et communique au besoin avec ses membres au moyen de
      courriels collectifs.
    </p>

    <p>
      D'autres activités combinent ornithologie et social. Une sortie à la
      cabane à sucre, des excursions ornithologiques en vélo ou en canot font
      aussi partie de nos projets.
    </p>

    <p>
      La majorité de nos activités sont réservées aux membres. Mais bien sûr,
      nous organisons aussi des activités ouvertes au public. Elles permettent
      aux gens qui y participent de s'initier à l'ornithologie ou d'échanger des
      connaissances dans un cadre décontracté.
    </p>
    <br/>

    <div class="section">
      <h2 class="pageSubtitle2">Le territoire couvert par le Club</h2>
      <p>Le COQ couvre plus particulièrement le <a href="/documents/territoire_coq_2012.jpg"
      >territoire de la Ville de Québec et de la Rive-sud de Québec ainsi que leurs environs</a> (municipalités et
        autres
        villes). Pour connaître le club d’ornithologie le plus près de votre région, consultez le site Web de <a
            href="https://gooiseaux.ca/carte-clubs/" target="_blank">Go oiseaux.ca</a> qui localise ceux-ci sur une
        carte
        géographique.</p>
      <p>Cependant, si vous décidez d’adhérer au COQ même si votre résidence est en dehors de son territoire, vous
        bénéficierez alors de tous les avantages réservés aux membres.</p>
    </div>

    <div class="section">
      <h2 class="pageSubtitle2">Les objectifs du COQ</h2>
      <ul>
        <li>
          Faire connaître les oiseaux dans un contexte de détente et de loisir et
          sensibiliser le public à la présence des oiseaux qui nous entourent ;
        </li>
        <li>Partager nos connaissances et nos expériences ;</li>
        <li>
          Veiller à la protection des oiseaux, de leurs habitats et des sites
          d’observation de la région ;
        </li>
        <li>
          Participer à l’amélioration des connaissances par des activités
          scientifiques.
        </li>
      </ul>
    </div>

    <div class="section">
      <h2 class="pageSubtitle2">Les excursions</h2>
      <img
          src="/images/excursion1_256px.jpg"
          style="float:right; margin-left:10px; box-shadow:5px 5px 5px #888888"
          alt=""
      />
      <p>
        L’observation des oiseaux dans leur milieu naturel demeure l’activité
        principale du Club. Des excursions sont organisées en toutes saisons. Les
        membres sont invités à explorer les sites ornithologiques de la grande
        région de Québec.
      </p>

      <p>
        Nos excursions ont lieu autant en semaine que les fins de semaine afin
        d'accomoder toutes les clientèles possibles. Comme certaines de nos
        excursions sont ouvertes au public, laissez-vous tenter de vous joindre à
        nous lors d'une de ces sorties sur le terrain !
      </p>

      <p>
        Vous n'avez qu'à jeter un coup d'oeil à notre
        <router-link :to="{ name: 'ActivitesPage' }">calendrier</router-link>
        des activités à venir et y rechercher une activité avec la mention «
        Bienvenue à tous ». Il nous fera plaisir de vous compter parmi nous !
      </p>
    </div>

    <div class="section">
      <h2 class="pageSubtitle2">Privilèges d'accès</h2>

      <p><strong>Pointe de Maizerets</strong></p>
      <p>Sur présentation de la carte de membre, l’accès et le stationnement à la Pointe de Maizerets (Baie-de-Beauport)
        sont gratuits pour les membres du COQ. Cet accès privilégié permet d’aller observer les oiseaux dans un des
        meilleurs sites de la région.</p>

      <p><strong>Entente avec deux instances de la SÉPAQ</strong></p>
      <p>Les directions du Parc national de la Jacques-Cartier et du Parc de la Chute-Montmorency
        sont fières de s’associer au Club. L’accès est gratuit, du 1<sup>er</sup>&nbsp;avril 2024 au 31&nbsp;mars 2025, en présentant votre carte de membre et une pièce d’identité.
      </p>

      <p>En contrepartie, le membre devra :</p>
      <ul>
        <li>compléter un <a href="https:// www.oiseauxqc.org/feuillet.pdf" target="_blank"> feuillet d’observation
          quotidienne</a> et le remettre à un préposé à l’accueil avant de quitter le parc ou,
        </li>
        <li>soumettre les données directement sur eBird et transmettre le numéro de la
          liste d’observation à un préposé à l'accueil.</li>
          </ul>
            
              <p>Cette liste devra être suffisamment étoffée en adéquation avec le privilège de l’entrée à titre
                gracieux sur le site. La remise de la liste des oiseaux observés est essentielle car les informations
                qu’elle contient contribuent à améliorer la connaissance sur les oiseaux qui fréquentent les parcs qui
                participent à l’entente.</p>

    </div>

    <div class="section">
      <h2 class="pageSubtitle2">Groupe d'échange Facebook</h2>
      <p>
        Joignez-vous au <a href="https://www.facebook.com/groups/565783517668485" target="_blank">Groupe d'échange et
        d'apprentissage sur les oiseaux du COQ</a>. Réservé aux membres seulement, le groupe favorise les échanges, les
        discussions et la diffusion d’information sur les oiseaux, que vous soyez débutants ou experts. Les
        administrateurs du groupe se feront un plaisir de répondre vos questions.
      </p>
    </div>

    <div class="section">
      <h2 class="pageSubtitle2">Conférences</h2>
      <img
          src="/images/conference.png"
          style="float:left; margin-right:10px"
          alt=""
      />
      <p>
        Le COQ organise sur une base mensuelle des conférences offertes au public
        avec tarif préférentiel aux membres. Divers sujets sont abordés. Par
        exemple : les oiseaux de mangeoire, les oiseaux de proie, les prédateurs
        des oiseaux et de leurs nids, le matériel d’optique, les plantes qui
        permettent d’attirer des oiseaux...
      </p>

      <p>
        Consultez le
        <router-link :to="{ name: 'ActivitesPage' }">calendrier</router-link>
        de nos activités afin de voir les conférences à venir.
      </p>
    </div>

    <div class="section">
      <h2 class="pageSubtitle2">Cours d'ornithologie</h2>
      <img
          src="/images/chouette_livre155.png"
          style="float:right; margin-left:10px; margin-top:20px"
          alt=""
      />
      <p>
        En tant que membre vous pourrez vous inscrire à plusieurs cours portant
        sur l'ornithologie. Si vous désirez acquérir des connaissances de base sur
        les oiseaux, les cours d’initiation à l’ornithologie niveaux 1 et 2 sont
        pour vous. Le Club offre d’autres cours plus avancés qui portent sur un
        seul sujet spécialisé, tel que les parulines, les limicoles, les rapaces,
        etc.
      </p>
      <p>
        Ces cours d’ornithologie sont offerts l’hiver, au printemps et à
        l’automne. Certains cours s’adressent aux débutants et d’autres sont
        offerts aux plus avancés.
      </p>

      <p>
        Pour voir le contenu détaillé de chaque cours, cliquez
        <router-link :to="{ name: 'CoursInitPage' }">ici</router-link>
        .
      </p>
    </div>

    <div class="section">
      <h2 class="pageSubtitle2">Social ornitho - 5 à 7</h2>
      <img
          src="/images/groupe.png"
          style="float:left; margin-right:10px;"
          alt=""
      />
      <p>
        Pour discuter d’ornithologie et se rencontrer dans une atmosphère décontractée, nous offrons parfois à nos
        membres la possibilité d’échanger lors de 5 à 7. Nous faisons connaître cette activité dans notre calendrier
        saisonnier ou par courriel collectif..
      </p>

      <p>
        Cette activité se déroule au restaurant L’Oeuforie Steak-Frites (850,
        boul. Pierre Bertrand, Vanier, Québec). Il y a relâche d'avril à août
        inclusivement.
      </p>
    </div>

    <div class="section">
      <h2 class="pageSubtitle2">Autres activités</h2>
      <p>
        Chaque année, par le biais de ses membres, le Club organise et participe à
        plusieurs activités d’inventaire qui permettent de recueillir des données
        essentielles sur les oiseaux de chez nous. Ces activités comprennent,
        entre autres, le Recensement de Noël et les recensements de la Réserve
        nationale de faune du cap Tourmente.
      </p>

      <img
          src="/images/cardinal_gagnant90px.jpg"
          style="float:right; margin-right:10px; margin-left:10px"
          alt=""
      />
      <p>
        Afin de stimuler ses troupes le Club organise annuellement deux
        compétitions amicales: l'<span style="color:#b1661b; font-weight:bold;"
      >Avicourse</span
      >
        et l'<span style="color:#b1661b; font-weight:bold;"
      >Écolo-défi... de ma fenêtre</span
      >. L'<span style="color:#b1661b; font-weight:bold;">Avicourse</span> dure
        trois mois durant lesquels les membres doivent dénombrer le plus grand
        nombre possible d'espèces d'oiseaux. Une soirée de remise de prix a lieu à
        la fin de la période.<br/>
        Plus de détails
        <router-link :to="{ name: 'AvicoursePage' }">ici</router-link>
        .
      </p>

      <img
          src="/images/fenetre110px.jpg"
          style="float:left; margin-left:10px; margin-right:20px; margin-top:5px; box-shadow:5px 5px 5px #888888"
          alt=""
      />
      <p>
        L'<span style="color:#b1661b; font-weight:bold;">Écolo-défi... de ma fenêtre</span>
        est une autre compétition dans laquelle les membres doivent dénombrer le
        plus grand nombre d'espèces d'oiseaux. Le défi dure environ les trois mois
        d'hiver, mais la particularité de cette compétition réside dans le fait
        que les observations doivent s'effectuer à partir d'une seule fenêtre ! Là
        aussi, une soirée de remise de prix se tient peu après la fin de la
        compétition.<br/>
        Plus de détails
        <router-link :to="{ name: 'EcoloDefiPage' }">ici</router-link>
        .
      </p>
    </div>

    <div class="section">
      <h2 class="pageSubtitle2">Tarification</h2>
      <ul>
        <li>22 $ : Adhésion d’<b>une personne</b> pour <b>un an</b>;</li>
        <li>40 $ : Adhésion d’<b>une personne</b> pour <b>2 ans</b>;</li>
        <li>32 $ : Adhésion d'<b>un ou de plusieurs membres</b> d'une même famille pour <b>un an</b>;</li>
        <li>56 $ : Adhésion d'<b>un ou de plusieurs membres</b> d'une même famille pour <b>2 ans</b>;</li>
        <li>15 $ : Adhésion pour <b>un étudiant</b> pour <b>un an</b>. (Pour la définition du statut d’étudiant, voir
          les <a href="/documents/reglements/reglements-generaux.pdf">règlements du COQ</a>.)
        </li>
      </ul>
      <br/>
      <p>
        Pour faciliter votre adhésion ou votre renouvellement, consultez le <a
          href="/documents/site-internet-document-aide.pdf">document d’aide</a>
        ainsi que la <a href="/politique-confidentialite">Politique de confidentialité du COQ</a>.
      </p>
      <p>
        Consultez la <a href="/documents/territoire_coq_2012.jpg">carte du territoire</a> couvert par le COQ
        pour savoir si vous en faites partie.
      </p>
    </div>

    <p>
      Voici donc un résumé des avantages de faire partie du Club. Nous vous
      invitons à vous joindre à nous. Il vous suffit de presser le bouton
      suivant afin d'accéder au formulaire d'inscription. Au plaisir !
    </p>

    <div style="text-align:center">
      <button
          class="btn btn-primary"
          disabled
          v-if="!isConnected"
      >
        Je veux créer mon compte COQ
      </button>
      <p v-else style="padding-top: 20px;">
        <router-link class="btn btn-primary" style="color: white; width: 100%" :to="{ name: 'MembersPage' }">Section
          membre
        </router-link>
      </p>
    </div>
    <br/><br/><br/><br/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'member-before-create-account',
    computed: {
      ...mapGetters({
        isConnected: 'account/isConnected'
      })
    },
    methods: {

      /**
       * Ne peut pas s'inscrire si l'utilisateur est déja connecté ou si il y a déjà une inscription
       * dans le panier
       */
      inscriptionLink() {
        if (this.isConnected === true) {
          this.$swal({
            type: 'error',
            title: 'Erreur',
            text: 'Vous ne pouvez pas vous inscrire si vous êtes déjà connecté',
            confirmButtonText: 'Fermer'
          });
        }
        else {
          this.$router.push({ name: 'InscriptionPage' });
        }
      }
    }
  };
</script>

<style scoped>
p {
  margin-left: 0 !important;
}

li {
  margin-bottom: 0;
}

.section {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
